<script>

import axios from 'axios';

export default class SeguradosRepository{
    
    async getSegurados(token,page,filters){
        
        const baseURL = page
        const headers = {
            'Accept':'application/json',
            'Authorization':'Bearer '+token
        };
        const data = filters;
        const response = await axios.post(baseURL, data,{headers:headers});
        return response;

    }

    async createSegurado(page,rawdata,token){
        
        const baseURL = page;
        const headers = {
            'Content-Type':'application/json',
            'Accept':'application/json',
            'Authorization':'Bearer '+token
        };
    
        try {
            const data = rawdata;
            const response = await axios.post(baseURL, data, { headers: headers });
            return response;
        } catch (error) {
            console.error("Erro ao enviar dados:", error.response ? error.response.data : error.message);
            throw error;
        }

    }

    async vincularEmpresas(token, empresaId, seguradoId) {
          console.log(empresaId)
        const baseURL = `${process.env.VUE_APP_API_URL}segurados/${seguradoId}/empresas`; // singular, como combinamos
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        try {
            const data = {
            empresa_id: empresaId
            };

            const response = await axios.post(baseURL, data, { headers });
            return response;
        } catch (error) {
            console.error("Erro ao enviar dados:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    async  deleteSegurado(page,token,id) {
        
        const baseURL = `${page}/${id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.delete(baseURL,{ headers });
        return response;
       
    }

    async  getSegurado(page,token,id,type) {
        
        const baseURL = `${page}/${id}/${type}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.get(baseURL,{ headers });
        return response;
       
    }

    async  updateSegurado(page,token,id,rawdata) {
        
        const baseURL = `${page}/${id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const data = rawdata;
        const response = await axios.put(baseURL,data,{ headers });
        return response;
       
    }

    async importSeguradoFile(data,token,page){

        const baseURL = page;
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };

        const formData = data
        //formData.append('myFile', file);

        const response = await axios.post(baseURL, formData, { headers: headers });
        return response;

    }

    async importApoliceFile(data, token) {
        const baseURL = `${process.env.VUE_APP_API_URL}uploads/apolices`;
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const formData = data;
        const response = await axios.post(baseURL, formData, { headers: headers });
        return response;
    }

    async FilterSegurado(page,rawdata,token){
        
        const baseURL = page;
        const headers = {
            'Content-Type':'application/json',
            'Accept':'application/json',
            'Authorization':'Bearer '+token
        };
    
        try {
            const data = rawdata;
            const response = await axios.post(baseURL, data, { headers: headers });
            return response;
        } catch (error) {
            console.error("Erro ao enviar dados:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    async cancelarVinculoApolice(token, vinculoId, dataCancelamento) {
        const baseURL = `${process.env.VUE_APP_API_URL}segurado-apolice/${vinculoId}/cancelar`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        try {
            const response = await axios.patch(baseURL, { data_cancelamento: dataCancelamento }, { headers });
            return response;
        } catch (error) {
            console.error("Erro ao cancelar vínculo:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    async getCertificateData(token, vinculoId) {
        const baseURL = `${process.env.VUE_APP_API_URL}segurado-apolice/${vinculoId}/certificate-data`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        try {
            const response = await axios.get(baseURL, { headers });
            return response;
        } catch (error) {
            console.error("Erro ao buscar dados do certificado:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    async uploadCertificate(token, vinculoId, file) {
        const baseURL = `${process.env.VUE_APP_API_URL}segurado-apolice/${vinculoId}/upload-certificate`;
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        try {
            const formData = new FormData();
            formData.append('certificate', file);
            const response = await axios.post(baseURL, formData, { headers });
            return response;
        } catch (error) {
            console.error("Erro ao fazer upload do certificado:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    async deleteCertificate(token, vinculoId) {
        const baseURL = `${process.env.VUE_APP_API_URL}segurado-apolice/${vinculoId}/delete-certificate`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        try {
            const response = await axios.delete(baseURL, { headers });
            return response;
        } catch (error) {
            console.error("Erro ao deletar certificado:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

}
</script>
